module.exports = __webpack_public_path__ + "img/button_double_chevron_left.e1031254.svg";